import { render, staticRenderFns } from "./DashSuperAdmin.vue?vue&type=template&id=07550460&"
import script from "./DashSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./DashSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports